import { useLazyQuery } from '@apollo/client';

const useV2LazyQuery: typeof useLazyQuery = (query, options, ...rest) => {
  return useLazyQuery(
    query,
    {
      ...options,
      context: {
        ...options?.context,
        useV2: true,
      },
    },
    ...rest,
  );
};

export default useV2LazyQuery;
